/**
 * Step 4 · Data & Exploration
 * Drillhole (collar, survey, assay, lithology, density, QAQC) + boundary + DEM.
 * Delegates entirely to the existing Section9Uploads component so uploads
 * are staged against the same draft project id.
 */
import { StepHeader } from "./Step1Identity";
import Section9Uploads from "../Section9Uploads";

export default function Step4Data({ form, set, onUploadsChange }) {
  return (
    <section className="space-y-4" data-testid="step-4-data">
      <StepHeader step="Step 4" title="Data & Uploads"
        subtitle="Upload drillhole data, project boundary and DEM. All uploads stage against the draft project — nothing is lost if you go back or refresh." />
      <Section9Uploads form={form} set={set} onUploadsChange={onUploadsChange} />
    </section>
  );
}
